var _rect, _path, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConnectorDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 4,
    fill: "url(#msGradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7V9H9V12C9 13.1046 9.89543 14 11 14H13C14.1046 14 15 13.1046 15 12V9H16V7H8Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 4,
    height: 2,
    rx: 0.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 16,
    width: 2,
    height: 2,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "msGradient",
    x1: 2,
    y1: 2,
    x2: 22,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#005A9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConnectorDefault);
export default __webpack_public_path__ + "static/media/icon_connector_default.c917b49d38f5c0221a46d11e339994eb.svg";
export { ForwardRef as ReactComponent };